import Link from 'next/link';

export default function FinalCTASection() {
  return (
    <section className="py-20 lg:py-24" style={{ backgroundColor: '#272727' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left content — 3 cols */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8" style={{ backgroundColor: 'rgba(0,150,136,0.4)' }} />
              <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(0,150,136,0.75)' }}>
                Serviço GP Otimiza da GestPub
              </span>
            </div>
            <h2
              className="text-white"
              style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.3, fontWeight: 700, marginBottom: '1.125rem', letterSpacing: '-0.02em' }}
            >
              Quer perceber como está a capacidade organizacional do seu Município?
            </h2>
            <p
              style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', maxWidth: '50ch', color: 'rgba(255,255,255,0.6)', lineHeight: 1.75 }}
            >
              Realize o diagnóstico gratuito ou agende uma reunião com a equipa da GestPub para perceber como o GP Otimiza pode ser aplicado à realidade do seu Município.
            </p>
          </div>

          {/* Right CTA box — 2 cols */}
          <div className="lg:col-span-2">
            <div
              className="p-7"
              style={{ borderRadius: '6px', backgroundColor: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
            >
              <Link
                href="/multi-step-questionnaire"
                className="flex items-center justify-center gap-2.5 w-full bg-white font-semibold text-sm transition-all duration-200 hover:bg-gray-100 mb-3"
                style={{ fontFamily: 'DM Sans, sans-serif', borderRadius: '4px', padding: '0.875rem 2rem', color: '#1a1a1a', letterSpacing: '0.01em' }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                  <rect x="9" y="3" width="6" height="4" rx="1" />
                  <line x1="9" y1="12" x2="15" y2="12" />
                  <line x1="9" y1="16" x2="12" y2="16" />
                </svg>
                Iniciar diagnóstico gratuito
              </Link>

              <a
                href="https://www.gestpub.pt/contactos/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2.5 w-full font-medium text-sm transition-all duration-200 mb-7"
                style={{ fontFamily: 'DM Sans, sans-serif', borderRadius: '4px', border: '1px solid rgba(255,255,255,0.18)', padding: '0.75rem 2rem', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.01em' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.35)'; (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.9)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.18)'; (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.7)'; }}
              >
                Agendar reunião de análise
              </a>

              <div className="space-y-2.5" style={{ borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: '1.25rem' }}>
                {[
                  'Diagnóstico gratuito',
                  'Confidencialidade garantida',
                  'Resultado imediato',
                  'Serviço especializado da GestPub',
                ].map((text) => (
                  <div key={text} className="flex items-center gap-3" style={{ color: 'rgba(255,255,255,0.42)' }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(0,150,136,0.55)" strokeWidth="2.5" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem' }}>{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}